import { render } from "./courseOutline.vue?vue&type=template&id=189bb0ac&scoped=true"
import script from "./courseOutline.vue?vue&type=script&lang=js"
export * from "./courseOutline.vue?vue&type=script&lang=js"

import "./courseOutline.vue?vue&type=style&index=0&id=189bb0ac&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-189bb0ac"]])

export default __exports__